(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-principal-lop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('banner-principal-lop')) {
    class BannerPrincipalLop extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.live = this.querySelector('[data-live]');
        this.total = this.slides.length;
        this.index = 0;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.intervalMs = Number(this.dataset.interval) || 5000;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.timer = null;
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.onVisibility = this.onVisibility.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        if (this.total <= 1) return;

        this.prevBtn?.addEventListener('click', () => this.goTo(this.index - 1, true));
        this.nextBtn?.addEventListener('click', () => this.goTo(this.index + 1, true));
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i, true));
        });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);

        this.goTo(0, false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onVisibility() {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1, true);
        }
      }

      onTouchStart(event) {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }

      onTouchEnd(event) {
        const touch = event.changedTouches[0];
        const dx = touch.clientX - this.touchStartX;
        const dy = touch.clientY - this.touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) this.goTo(this.index + 1, true);
        else this.goTo(this.index - 1, true);
      }

      goTo(index, fromUser) {
        if (this.total <= 1) return;
        this.index = (index + this.total) % this.total;
        this.track.style.transform = 'translateX(' + this.index * -100 + '%)';

        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
        });

        this.dots.forEach((dot, i) => {
          const active = i === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (this.live) {
          this.live.textContent = 'Diapositiva ' + (this.index + 1) + ' de ' + this.total;
        }

        if (fromUser) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.autoplayEnabled || this.reduceMotion || this.total <= 1 || document.hidden) return;
        this.timer = setInterval(() => this.goTo(this.index + 1, false), this.intervalMs);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('banner-principal-lop', BannerPrincipalLop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-confianza-lop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('barra-confianza-lop')) {
    class BarraConfianzaLop extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-track]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.total = this.items.length;
        this.index = 0;
        this.intervalMs = Number(this.dataset.interval) || 4000;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mq = window.matchMedia('(min-width: 750px)');
        this.timer = null;
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.onResize = this.onResize.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onKeydown = this.onKeydown.bind(this);

        if (this.total <= 1) return;

        this.mq.addEventListener('change', this.onResize);
        window.addEventListener('resize', this.onResize);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.addEventListener('keydown', this.onKeydown);

        this.onResize();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.mq?.removeEventListener('change', this.onResize);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      get isDesktop() {
        return this.mq.matches;
      }

      get viewport() {
        return this.querySelector('.lop-trust__viewport');
      }

      getSnapOffsets() {
        const viewportWidth = this.viewport ? this.viewport.clientWidth : 0;
        const maxOffset = Math.max(0, this.track.scrollWidth - viewportWidth);
        const offsets = [0];

        this.items.forEach((item, i) => {
          if (i === 0) return;
          const left = item.offsetLeft;
          if (left < maxOffset - 1) offsets.push(left);
        });

        if (maxOffset > 1 && offsets[offsets.length - 1] < maxOffset - 1) {
          offsets.push(maxOffset);
        }

        return offsets;
      }

      onResize() {
        if (this.isDesktop || this.total <= 1) {
          this.index = 0;
          this.track.style.transform = '';
          this.stopAutoplay();
          return;
        }

        this.goTo(this.index, false);
        this.startAutoplay();
      }

      onVisibility() {
        if (document.hidden) this.stopAutoplay();
        else this.startAutoplay();
      }

      onKeydown(event) {
        if (this.isDesktop) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1, true);
        }
      }

      onTouchStart(event) {
        if (this.isDesktop) return;
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }

      onTouchEnd(event) {
        if (this.isDesktop) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - this.touchStartX;
        const dy = touch.clientY - this.touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) this.goTo(this.index + 1, true);
        else this.goTo(this.index - 1, true);
      }

      goTo(index, fromUser) {
        if (this.isDesktop || this.total <= 1) return;

        const offsets = this.getSnapOffsets();
        const max = offsets.length - 1;
        if (max < 1) {
          this.index = 0;
          this.track.style.transform = '';
          this.stopAutoplay();
          return;
        }

        if (index > max) index = 0;
        else if (index < 0) index = max;
        this.index = index;

        this.track.style.transform = 'translateX(' + -offsets[this.index] + 'px)';

        if (fromUser) {
          this.stopAutoplay();
          this.startAutoplay();
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.reduceMotion || this.isDesktop || this.total <= 1 || document.hidden) return;
        this.timer = setInterval(() => this.goTo(this.index + 1, false), this.intervalMs);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define('barra-confianza-lop', BarraConfianzaLop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-productos-lop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carrusel-productos-lop')) {
    class CarruselProductosLop extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;

          this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-panel]'));
          this.ctas = Array.from(this.querySelectorAll('[data-cta]'));
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.onTabClick = this.onTabClick.bind(this);
          this.onTabKeydown = this.onTabKeydown.bind(this);
          this.onResize = this.onResize.bind(this);
          this.onVariantUpdate = this.onVariantUpdate.bind(this);

          this.imageTokens = new WeakMap();

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', this.onTabClick);
            tab.addEventListener('keydown', this.onTabKeydown);
          });

          this.panels.forEach((panel) => this.setupPanel(panel));

          this.resizeObserver = new ResizeObserver(this.onResize);
        }

        // Capture phase: `product-card` stops this event from bubbling any further.
        this.addEventListener('variant:update', this.onVariantUpdate, true);
        this.resizeObserver.observe(this);
        this.refreshVisible();
      }

      disconnectedCallback() {
        this.removeEventListener('variant:update', this.onVariantUpdate, true);
        if (this.resizeObserver) this.resizeObserver.unobserve(this);
      }

      setupPanel(panel) {
        const track = panel.querySelector('[data-track]');
        if (!track) return;

        let frame = null;
        track.addEventListener(
          'scroll',
          () => {
            if (frame) return;
            frame = requestAnimationFrame(() => {
              frame = null;
              this.refreshPanel(panel);
            });
          },
          { passive: true }
        );

        const prev = panel.querySelector('[data-prev]');
        const next = panel.querySelector('[data-next]');

        if (prev) prev.addEventListener('click', () => this.scrollByPage(track, -1));
        if (next) next.addEventListener('click', () => this.scrollByPage(track, 1));
      }

      scrollByPage(track, direction) {
        track.scrollBy({
          left: direction * track.clientWidth,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }

      onTabClick(event) {
        this.activate(event.currentTarget.dataset.tab, false);
      }

      onTabKeydown(event) {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(event.key) === -1) return;

        event.preventDefault();

        const total = this.tabs.length;
        const current = this.tabs.indexOf(event.currentTarget);
        let index = current;

        if (event.key === 'ArrowLeft') index = current - 1;
        else if (event.key === 'ArrowRight') index = current + 1;
        else if (event.key === 'Home') index = 0;
        else index = total - 1;

        if (index < 0) index = total - 1;
        if (index >= total) index = 0;

        this.activate(this.tabs[index].dataset.tab, true);
      }

      activate(id, focusTab) {
        if (!id) return;

        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tab === id;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive && focusTab) tab.focus();
        });

        this.ctas.forEach((cta) => {
          cta.hidden = cta.dataset.cta !== id;
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.panel === id;
          panel.hidden = !isActive;

          if (!isActive) return;

          const track = panel.querySelector('[data-track]');
          if (track) track.scrollLeft = 0;
          this.refreshPanel(panel);
        });
      }

      /**
       * The theme already fetches the selected variant when a swatch is clicked, so we
       * reuse that payload to refresh the card instead of requesting anything else.
       */
      onVariantUpdate(event) {
        const target = event.target;
        const card = target instanceof Element ? target.closest('.lop-pcard') : null;
        const variant = event.detail && event.detail.resource;

        if (!card || !variant) return;

        this.updateCardImage(card, variant);
        this.updateCardPrice(card, event.detail.data && event.detail.data.html);
        this.updateCardSku(card, variant);
      }

      updateCardImage(card, variant) {
        const image = card.querySelector('.lop-pcard__image--primary');
        const preview = variant.featured_media && variant.featured_media.preview_image;

        if (!(image instanceof HTMLImageElement) || !preview || !preview.src) return;

        const base = preview.src + (preview.src.indexOf('?') === -1 ? '?' : '&');
        const srcset = [160, 240, 320, 432, 640, 800]
          .map((width) => base + 'width=' + width + ' ' + width + 'w')
          .join(', ');
        const src = base + 'width=800';

        if (image.getAttribute('src') === src) return;

        const token = (this.imageTokens.get(card) || 0) + 1;
        this.imageTokens.set(card, token);

        // Load the new image off-DOM first so the card never shows an empty frame, and
        // drop the result if a newer swatch was clicked in the meantime.
        const probe = new Image();
        const apply = () => {
          if (this.imageTokens.get(card) !== token) return;

          image.srcset = srcset;
          image.src = src;
          if (preview.width) image.width = preview.width;
          if (preview.height) image.height = preview.height;
          card.classList.add('is-variant-selected');
        };

        probe.sizes = image.sizes;
        probe.srcset = srcset;
        probe.src = src;

        if (probe.complete) {
          apply();
        } else {
          probe.addEventListener('load', apply, { once: true });
        }
      }

      updateCardPrice(card, html) {
        if (!html) return;

        const source = html.querySelector("product-price [ref='priceContainer']");
        const price = card.querySelector('.lop-pcard__price');

        if (!source || !price) return;

        const newPrice = source.querySelector('.price');
        if (newPrice) price.textContent = newPrice.textContent.trim();

        const compare = card.querySelector('.lop-pcard__price-compare');
        if (!compare) return;

        const newCompare = source.querySelector('.compare-at-price');
        compare.textContent = newCompare ? newCompare.textContent.trim() : '';
        compare.hidden = !newCompare;
      }

      updateCardSku(card, variant) {
        const sku = card.querySelector('.lop-pcard__sku');
        if (sku) sku.textContent = variant.sku || '';
      }

      onResize() {
        this.refreshVisible();
      }

      refreshVisible() {
        this.panels.forEach((panel) => {
          if (!panel.hidden) this.refreshPanel(panel);
        });
      }

      refreshPanel(panel) {
        const track = panel.querySelector('[data-track]');
        if (!track) return;

        const maxScroll = track.scrollWidth - track.clientWidth;
        const prev = panel.querySelector('[data-prev]');
        const next = panel.querySelector('[data-next]');

        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxScroll - 1;

        this.refreshProgress(panel, track, maxScroll);
      }

      refreshProgress(panel, track, maxScroll) {
        const progress = panel.querySelector('[data-progress]');
        if (!progress) return;

        const pages = track.clientWidth > 0 ? Math.ceil(track.scrollWidth / track.clientWidth) : 0;

        if (pages <= 1) {
          progress.hidden = true;
          progress.replaceChildren();
          return;
        }

        progress.hidden = false;

        if (progress.children.length !== pages) {
          const items = [];
          for (let i = 0; i < pages; i++) {
            const item = document.createElement('span');
            item.className = 'lop-pcar__progress-item';
            items.push(item);
          }
          progress.replaceChildren(...items);
        }

        const active = maxScroll > 0 ? Math.round((track.scrollLeft / maxScroll) * (pages - 1)) : 0;

        Array.from(progress.children).forEach((item, index) => {
          item.classList.toggle('is-active', index === active);
        });
      }
    }

    customElements.define('carrusel-productos-lop', CarruselProductosLop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-lop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-lop')) {
    class FooterLop extends HTMLElement {
      connectedCallback() {
        this.accordions = this.querySelectorAll('[data-accordion]');
        this.mq = window.matchMedia('(min-width: 750px)');
        this.onChange = this.sync.bind(this);
        if (this.mq.addEventListener) {
          this.mq.addEventListener('change', this.onChange);
        } else {
          this.mq.addListener(this.onChange);
        }
        this.sync();
      }

      disconnectedCallback() {
        if (!this.mq) return;
        if (this.mq.removeEventListener) {
          this.mq.removeEventListener('change', this.onChange);
        } else {
          this.mq.removeListener(this.onChange);
        }
      }

      sync() {
        const desktop = this.mq.matches;
        this.accordions.forEach((el) => {
          if (desktop) {
            el.setAttribute('open', '');
          } else if (el.dataset.fromDesktop === 'true') {
            el.removeAttribute('open');
          }
          el.dataset.fromDesktop = desktop ? 'true' : 'false';
        });
      }
    }

    customElements.define('footer-lop', FooterLop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locales-lilipink"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var cards = document.querySelectorAll('.locales-card');
    var iframeWraps = document.querySelectorAll('.locales-map-iframe-wrap');
    var headerText = document.getElementById('localesMapHeaderText');

    // Cuando el usuario hace clic en una card, mostramos su iframe correspondiente
    cards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        // No hacer nada si clickeó un enlace dentro de la card
        if (e.target.closest('a')) return;

        var name = card.dataset.name;
        if (!name) return;

        iframeWraps.forEach(function(wrap) {
          if (wrap.dataset.storeName === name) {
            wrap.classList.add('is-active');
            if (headerText) headerText.textContent = '📍 ' + name;
          } else {
            wrap.classList.remove('is-active');
          }
        });

        // Scroll suave al mapa en mobile
        if (window.innerWidth < 750) {
          var mapWrap = document.querySelector('.locales-map-wrapper');
          if (mapWrap) mapWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // ============================================
    // FILTROS (sin tocar el mapa)
    // ============================================
    var zoneFilter = document.getElementById('localesZoneFilter');
    var searchInput = document.getElementById('localesSearchInput');
    var clearBtn = document.getElementById('localesClearFilters');
    var emptyMsg = document.getElementById('localesEmpty');

    function applyFilters() {
      var zone = zoneFilter ? zoneFilter.value.toLowerCase() : '';
      var search = searchInput ? searchInput.value.toLowerCase().trim() : '';
      var visibleCount = 0;

      cards.forEach(function(card) {
        var cardZone = (card.dataset.zone || '').toLowerCase();
        var cardName = (card.dataset.name || '').toLowerCase();
        var cardCity = (card.dataset.city || '').toLowerCase();
        var matchesZone = !zone || cardZone === zone;
        var matchesSearch = !search || cardName.indexOf(search) !== -1 || cardCity.indexOf(search) !== -1;

        if (matchesZone && matchesSearch) {
          card.classList.remove('is-hidden');
          visibleCount++;
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (emptyMsg) {
        emptyMsg.style.display = visibleCount === 0 ? 'block' : 'none';
      }
    }

    if (zoneFilter) zoneFilter.addEventListener('change', applyFilters);
    if (searchInput) searchInput.addEventListener('input', applyFilters);
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (zoneFilter) zoneFilter.value = '';
        if (searchInput) searchInput.value = '';
        applyFilters();
      });
    }
        // ============================================
    // AUTO-SELECCIÓN POR URL (?store=xxx)
    // ============================================
    var urlParams = new URLSearchParams(window.location.search);
    var storeParam = urlParams.get('store');
    
        if (storeParam) {
      var targetCard = document.querySelector('.locales-card[data-slug="' + storeParam + '"]');
      
      if (targetCard) {
        var storeName = targetCard.dataset.name;
        var iframeWraps = document.querySelectorAll('.locales-map-iframe-wrap');
        iframeWraps.forEach(function(wrap) {
          if (wrap.dataset.storeName === storeName) {
            wrap.classList.add('is-active');
          } else {
            wrap.classList.remove('is-active');
          }
        });

        // Ya no redeclarar headerText:
        if (headerText) headerText.textContent = '📍 ' + storeName;

        targetCard.classList.add('is-highlighted');
        setTimeout(function() {
          targetCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 400);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-suscripcion-lop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('newsletter-suscripcion-lop')) {
    class NewsletterSuscripcionLop extends HTMLElement {
      constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        this.form = this.querySelector('form');
        this.successEl = this.querySelector('[data-success]');
        this.submitEl = this.querySelector('[data-submit]');

        if (this.form && this.id && !this.form.action.includes('#')) {
          this.form.action = `${this.form.action}#${this.id}`;
        }

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit);
        }

        if (this.successEl && !this.successEl.hidden) {
          this.scrollIntoView({ block: 'center' });
          this.successEl.focus();
        }
      }

      disconnectedCallback() {
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmit);
        }
      }

      onSubmit() {
        if (!this.submitEl) return;
        this.submitEl.disabled = true;
        this.submitEl.setAttribute('aria-busy', 'true');
      }
    }

    customElements.define('newsletter-suscripcion-lop', NewsletterSuscripcionLop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-lilipink"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Galería: cambio de imagen
    const thumbs = document.querySelectorAll('.pdp-thumb');
    const mainImage = document.getElementById('pdpMainImage');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        if (mainImage) {
          mainImage.src = this.dataset.imageUrl;
        }
      });
    });

    // Cantidad: + y -
    const qtyInput = document.getElementById('pdpQty');
    document.querySelectorAll('.pdp-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        let val = parseInt(qtyInput.value) || 1;
        if (this.dataset.action === 'increase') val++;
        if (this.dataset.action === 'decrease' && val > 1) val--;
        qtyInput.value = val;
      });
    });

    // Opciones: selección
    document.querySelectorAll('.pdp-option-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const optionIndex = this.dataset.optionIndex;
        document.querySelectorAll('.pdp-option-btn[data-option-index="' + optionIndex + '"]').forEach(b => b.classList.remove('is-selected'));
        this.classList.add('is-selected');
      });
    });

    // Calculador de envío (placeholder)
    const zipBtn = document.getElementById('pdpZipBtn');
    if (zipBtn) {
      zipBtn.addEventListener('click', function() {
        const zip = document.getElementById('pdpZipInput').value.trim();
        const result = document.getElementById('pdpShippingResult');
        if (zip.length >= 4) {
          result.textContent = 'Envío estimado: 3-5 días hábiles. Envío gratis en compras desde $50.000.';
        } else {
          result.textContent = 'Ingresá un código postal válido.';
        }
      });
    }

    // Sticky: scroll al formulario
    const stickyBtn = document.getElementById('pdpStickyBtn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        document.querySelector('.pdp-add-to-cart').click();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-locales"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var overlay = document.getElementById('lpPopupOverlay');
    if (!overlay) return;

    var closeBtn = document.getElementById('lpPopupClose');
    var copyBtn = document.getElementById('lpPopupCopyBtn');
    var copyMsg = document.getElementById('lpPopupCopyMsg');
    var codeEl = document.getElementById('lpPopupCode');
    var CODE = codeEl ? codeEl.textContent.trim() : 'MiPrimerLiliPink';
    var delay = parseInt(overlay.dataset.delay) || 5000;
    var frequency = overlay.dataset.frequency || 'session';

    function canShow() {
      try {
        var key = 'lpPopupShown_' + frequency;
        var lastShown = sessionStorage.getItem(key) || localStorage.getItem(key);
        if (!lastShown) return true;
        var last = parseInt(lastShown);
        var now = Date.now();
        if (frequency === 'session') return false;
        if (frequency === 'day') return (now - last) > 24 * 60 * 60 * 1000;
        if (frequency === 'week') return (now - last) > 7 * 24 * 60 * 60 * 1000;
        return true;
      } catch (e) { return true; }
    }

    function markAsShown() {
      try {
        var key = 'lpPopupShown_' + frequency;
        if (frequency === 'session') sessionStorage.setItem(key, Date.now().toString());
        else localStorage.setItem(key, Date.now().toString());
      } catch (e) {}
    }

    function openPopup() {
      if (!canShow()) return;
      overlay.classList.add('is-open');
      markAsShown();
    }

    function closePopup() { overlay.classList.remove('is-open'); }

    setTimeout(openPopup, delay);

    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closePopup();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closePopup();
    });

    copyBtn.addEventListener('click', function() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).then(showCopied).catch(function() {
          fallbackCopy(CODE);
        });
      } else {
        fallbackCopy(CODE);
      }
    });

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); showCopied(); }
      catch (err) {
        copyMsg.textContent = 'No se pudo copiar. Copiá manualmente.';
        copyMsg.style.color = '#C62828';
        copyMsg.classList.add('is-visible');
      }
      document.body.removeChild(textarea);
    }

    function showCopied() {
      copyMsg.textContent = '✓ Copiado al portapapeles';
      copyMsg.style.color = '#4CAF50';
      copyMsg.classList.add('is-visible');
      copyBtn.classList.add('is-copied');
      copyBtn.textContent = '¡Copiado!';
      setTimeout(function() {
        copyBtn.classList.remove('is-copied');
        copyBtn.textContent = 'Copiar código';
      }, 2500);
      // Tracking opcional
      if (typeof fbq === 'function') {
        fbq('trackCustom', 'CopiarCodigoPopup', { code: CODE });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["productos-destacados-lop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('productos-destacados-lop')) {
    class ProductosDestacadosLop extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;

          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.imageTokens = new WeakMap();

          this.onResize = this.onResize.bind(this);
          this.onVariantUpdate = this.onVariantUpdate.bind(this);

          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.progress = this.querySelector('[data-progress]');

          if (this.track) {
            let frame = null;
            this.track.addEventListener(
              'scroll',
              () => {
                if (frame) return;
                frame = requestAnimationFrame(() => {
                  frame = null;
                  this.refresh();
                });
              },
              { passive: true }
            );

            if (this.prev) this.prev.addEventListener('click', () => this.scrollByPage(-1));
            if (this.next) this.next.addEventListener('click', () => this.scrollByPage(1));
          }

          this.resizeObserver = new ResizeObserver(this.onResize);
        }

        this.addEventListener('variant:update', this.onVariantUpdate, true);
        if (this.resizeObserver) this.resizeObserver.observe(this);
        this.refresh();
      }

      disconnectedCallback() {
        this.removeEventListener('variant:update', this.onVariantUpdate, true);
        if (this.resizeObserver) this.resizeObserver.unobserve(this);
      }

      scrollByPage(direction) {
        if (!this.track) return;

        this.track.scrollBy({
          left: direction * this.track.clientWidth,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }

      onVariantUpdate(event) {
        const target = event.target;
        const card = target instanceof Element ? target.closest('.lop-pcard') : null;
        const variant = event.detail && event.detail.resource;

        if (!card || !variant) return;

        this.updateCardImage(card, variant);
        this.updateCardPrice(card, event.detail.data && event.detail.data.html);
        this.updateCardSku(card, variant);
      }

      updateCardImage(card, variant) {
        const image = card.querySelector('.lop-pcard__image--primary');
        const preview = variant.featured_media && variant.featured_media.preview_image;

        if (!(image instanceof HTMLImageElement) || !preview || !preview.src) return;

        const base = preview.src + (preview.src.indexOf('?') === -1 ? '?' : '&');
        const srcset = [160, 240, 320, 432, 640, 800]
          .map((width) => base + 'width=' + width + ' ' + width + 'w')
          .join(', ');
        const src = base + 'width=800';

        if (image.getAttribute('src') === src) return;

        const token = (this.imageTokens.get(card) || 0) + 1;
        this.imageTokens.set(card, token);

        const probe = new Image();
        const apply = () => {
          if (this.imageTokens.get(card) !== token) return;

          image.srcset = srcset;
          image.src = src;
          if (preview.width) image.width = preview.width;
          if (preview.height) image.height = preview.height;
          card.classList.add('is-variant-selected');
        };

        probe.sizes = image.sizes;
        probe.srcset = srcset;
        probe.src = src;

        if (probe.complete) {
          apply();
        } else {
          probe.addEventListener('load', apply, { once: true });
        }
      }

      updateCardPrice(card, html) {
        if (!html) return;

        const source = html.querySelector("product-price [ref='priceContainer']");
        const price = card.querySelector('.lop-pcard__price');

        if (!source || !price) return;

        const newPrice = source.querySelector('.price');
        if (newPrice) price.textContent = newPrice.textContent.trim();

        const compare = card.querySelector('.lop-pcard__price-compare');
        if (!compare) return;

        const newCompare = source.querySelector('.compare-at-price');
        compare.textContent = newCompare ? newCompare.textContent.trim() : '';
        compare.hidden = !newCompare;
      }

      updateCardSku(card, variant) {
        const sku = card.querySelector('.lop-pcard__sku');
        if (sku) sku.textContent = variant.sku || '';
      }

      onResize() {
        this.refresh();
      }

      refresh() {
        if (!this.track) return;

        const maxScroll = this.track.scrollWidth - this.track.clientWidth;

        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
        if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 1;

        this.refreshProgress(maxScroll);
      }

      refreshProgress(maxScroll) {
        if (!this.progress) return;

        const pages = this.track.clientWidth > 0 ? Math.ceil(this.track.scrollWidth / this.track.clientWidth) : 0;

        if (pages <= 1) {
          this.progress.hidden = true;
          this.progress.replaceChildren();
          return;
        }

        this.progress.hidden = false;

        if (this.progress.children.length !== pages) {
          const items = [];
          for (let i = 0; i < pages; i++) {
            const item = document.createElement('span');
            item.className = 'lop-pdest__progress-item';
            items.push(item);
          }
          this.progress.replaceChildren(...items);
        }

        const active = maxScroll > 0 ? Math.round((this.track.scrollLeft / maxScroll) * (pages - 1)) : 0;

        Array.from(this.progress.children).forEach((item, index) => {
          item.classList.toggle('is-active', index === active);
        });
      }
    }

    customElements.define('productos-destacados-lop', ProductosDestacadosLop);
  }

  } catch(e) { console.error(e); }
})();
})();
